import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export const Blog_side_bar = ({ onCategorySelect, onTopicSelect }) => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeTopic, setActiveTopic] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://blogs.vananiassociates.com/api/categories');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        setData(result.data); // Access the `data` array from the response
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const handleCategoryClick = (slug) => {
    const isSameCategory = activeCategory === slug;
    setActiveCategory(isSameCategory ? null : slug);
    setActiveTopic(null); // Reset topic when selecting a new category
    onCategorySelect(isSameCategory ? null : slug);
  };

  const handleSubCategoryClick = (categorySlug, topicSlug) => {
    setActiveCategory(categorySlug); // Keep the category active
    setActiveTopic(activeTopic === topicSlug ? null : topicSlug);
    onTopicSelect(activeTopic !== topicSlug ? topicSlug : null);
  };

  return (
    <div className="container-no">
      <div className="blog_list_wrap sticky top-[130px] self-start border border-gray-300 shadow-sm rounded-md bg-white">
        <h4 className="!bg-gray-100 !py-3 !px-4 !m-0 !mb-3 !border-b !border-gray-300 !text-gray-800 font-semibold text-center">ALL BLOGS</h4>
        <div className="p-2 m-0">
          {data.map((category) => (
            <div key={category.slug} className="category-section">
              <Link
                className={`blog_title ${activeCategory === category.slug ? 'active' : ''}`}
                onClick={() => handleCategoryClick(category.slug)}
              >
                {category.name}
              </Link>
              <ul className="dropdaun list-unstyled">
                {category.topics.map((topic) => (
                  <li key={topic.slug}>
                    <Link
                      className={`blog_link ${activeTopic === topic.slug ? 'active' : ''}`}
                      onClick={() => handleSubCategoryClick(category.slug, topic.slug)}
                    >
                      {topic.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog_side_bar;
